module.exports = __webpack_public_path__ + "static/media/04.f6c21c86.jpg";